// modules/facturacion/components/EmitirModal.jsx
import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem, Alert, CircularProgress,
  Box, Divider, Grid,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import * as svc from "../services/facturacionService";

const EmitirModal = ({ open, onClose, factura, onSuccess }) => {
  const [form,    setForm]    = useState({
    actividadEconomica          : "",
    codigoSucursal              : 0,
    codigoPuntoVenta            : 0,
    codigoMetodoPago            : 2,
    codigoMoneda                : 1,
    codigoTipoDocumentoIdentidad: 5,
    unidadMedida                : 58,
    correo                      : "",
  });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  const handleChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async () => {
    if (!form.actividadEconomica) return setError("La actividad económica es requerida");
    setLoading(true);
    setError(null);
    try {
      await svc.emitir(factura.cod, form);
      onSuccess();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al emitir al SIAT");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Emitir al SIAT — Factura #{factura?.cod}</DialogTitle>
      <Divider />
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Alert severity="info" sx={{ mb: 2 }}>
            <strong>{factura?.fac_Nombre}</strong><br />
            NIT: {factura?.nit} · Monto: {Number(factura?.monto_total || 0).toFixed(2)}
          </Alert>

          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField fullWidth required size="small"
                label="Actividad Económica (cod_produccion)"
                name="actividadEconomica"
                value={form.actividadEconomica}
                onChange={handleChange}
                disabled={loading}
                helperText="Código de actividad del SIAT (ej: 461000)"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField select fullWidth size="small" label="Método de Pago"
                name="codigoMetodoPago" value={form.codigoMetodoPago}
                onChange={handleChange} disabled={loading}>
                <MenuItem value={1}>Efectivo</MenuItem>
                <MenuItem value={2}>Cheque</MenuItem>
                <MenuItem value={3}>Tarjeta débito</MenuItem>
                <MenuItem value={4}>Tarjeta crédito</MenuItem>
                <MenuItem value={5}>Transferencia</MenuItem>
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField select fullWidth size="small" label="Moneda"
                name="codigoMoneda" value={form.codigoMoneda}
                onChange={handleChange} disabled={loading}>
                <MenuItem value={1}>Bolivianos</MenuItem>
                <MenuItem value={2}>Dólares</MenuItem>
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField fullWidth size="small" label="Código Sucursal SIAT"
                name="codigoSucursal" type="number"
                value={form.codigoSucursal}
                onChange={handleChange} disabled={loading} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField fullWidth size="small" label="Código Punto de Venta"
                name="codigoPuntoVenta" type="number"
                value={form.codigoPuntoVenta}
                onChange={handleChange} disabled={loading} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField fullWidth size="small" label="Correo (opcional)"
                name="correo" type="email"
                value={form.correo}
                onChange={handleChange} disabled={loading} />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : <SendIcon />}>
          {loading ? "Emitiendo..." : "Emitir al SIAT"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmitirModal;